<script>
export default {
	data() {
		return {
			creditCardStartingBalance: 100
		};
	},
	computed: {
		lifeStageData() {
			return this.$store.getters.lifeStageData;
		},
		avatarImg() {
			return this.$store.getters.avatarImg;
		},
		isInBudgetingPhase() {
			return this.$store.getters.isInBudgetingPhase;
		},
		isLoanRequired() {
			return this.$store.getters.isLoanRequired;
		},
		autoLoan() {
			return this.$store.getters.autoLoan;
		},
		autoLoanBankingAndFinance() {
			return this.$store.getters.autoLoanBankingAndFinance;
		},
		mortgageLoan() {
			return this.$store.getters.mortgageLoan;
		},
		isAnyLoanVisible() {
			return (
				this.$store.getters.isAutoLoanDealershipVisible ||
				this.$store.getters.isAutoLoanFinanceVisible ||
				this.$store.getters.isMortgageLoanVisible
			);
		},
		hasAutoLoanTriggerLoansModal() {
			return (
				(this.$store.getters.isAutoLoanDealershipVisible ||
					this.$store.getters.isAutoLoanFinanceVisible) &&
				!this.$store.getters.isAutoLoanApplied
			);
		},
		hasMortgageLoanTriggerLoansModal() {
			return (
				this.$store.getters.isMortgageLoanVisible &&
				!this.$store.getters.isMortgageLoanApplied
			);
		},
		areLoansAvailableBySimulation() {
			return this.$store.getters.areLoansAvailableBySimulation;
		}
	},
	methods: {
		checkForLifeStageData(forceUpdate) {
			if (!this.lifeStageData || forceUpdate) {
				this.$store.dispatch('getLifeStageData');
			}

			if (this.isInBudgetingPhase && this.lifeStageData) {
				this.$store.dispatch('getInitialDebt');
			}
		}
	}
};
</script>
